module.exports = __webpack_public_path__ + "img/8.8b1588f1.jpg";